import React from "react";
import { connect } from "react-redux";
import { FirstChartData, FourthChartData, SecondChartData, ThirdChartData } from "../Data/DashboardData/FirstChartData";
import Apex from "./Apex";

function ChartSmallCard({ dashboardData, loading }) {
    // Get trade stats from dashboard API response
    const tradeStats = dashboardData?.data?.trades?.stats || dashboardData?.trades?.stats || {};
    
    // Prepare trade stats cards data
    const tradeStatsCards = [
        {
            title: "Total Trades",
            value: tradeStats.totalTrades || 0,
            icon: "fa fa-exchange-alt",
            colorClass: "color-price-up",
            chartData: FirstChartData,
        },
        {
            title: "Total Profit",
            value: tradeStats.totalProfit || 0,
            icon: "fa fa-arrow-up",
            colorClass: "text-success",
            chartData: SecondChartData,
            isCurrency: true,
        },
        {
            title: "Total Loss",
            value: tradeStats.totalLoss || 0,
            icon: "fa fa-arrow-down",
            colorClass: "text-danger",
            chartData: ThirdChartData,
            isCurrency: true,
        },
        {
            title: "Profit Trades",
            value: tradeStats.profitTrades || 0,
            icon: "fa fa-check-circle",
            colorClass: "text-success",
            chartData: FourthChartData,
        },
    ];

    const formatValue = (value, isCurrency = false, suffix = "") => {
        if (value === null || value === undefined) return '0';
        const numValue = typeof value === 'number' ? value : parseFloat(value) || 0;
        if (isCurrency) {
            return `${numValue.toLocaleString('en-US', { maximumFractionDigits: 2, minimumFractionDigits: 2 })}`;
        }
        return `${numValue.toLocaleString('en-US', { maximumFractionDigits: 2 })}${suffix}`;
    };

    if (loading && !dashboardData) {
    return (
        <div className="row g-3 mb-3 row-cols-1 row-cols-md-2 row-cols-lg-4">
                {[1, 2, 3, 4].map(i => (
                    <div className="col" key={i}>
                <div className="card">
                            <div className="card-body">
                                <div className="text-center py-4">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
                </div>
        );
    }

    return (
        <div className="row g-3 mb-3 row-cols-1 row-cols-md-2 row-cols-lg-4">
            {tradeStatsCards.map((item, index) => {
                return (
                    <div className="col" key={index}>
                <div className="card">
                    <div className="card-body d-flex align-items-center">
                        <div className="flex-fill text-truncate">
                                    <span className="text-muted small text-uppercase d-flex align-items-center mb-2">
                                        <i className={`${item.icon} me-2`}></i>
                                        {item.title}
                                    </span>
                            <div className="d-flex flex-column">
                                <div className="price-block">
                                            <span className={`fs-6 fw-bold ${item.colorClass}`}>
                                                {formatValue(item.value, item.isCurrency, item.suffix)}
                                            </span>
                                </div>
                            </div>
                        </div>
                    </div>
                            {item.chartData && item.chartData.map((data, i) => {
                                return <Apex data={data} key={`chart-${index}-${i}`} />
                            })}
                                </div>
                            </div>
                );
            })}
        </div>
    )
}

const mapStateToProps = (state) => ({
    dashboardData: state.data?.dashboard,
    loading: state.data?.loading?.dashboard || false,
});

export default connect(mapStateToProps)(ChartSmallCard);